import React from 'react';
import { Message, MessageBody } from './styles.chatcomponents';
import DOMPurify from 'dompurify';

const MessageComponent = ({ type, body, media }) => {
  const htmlContent = { __html: DOMPurify.sanitize(body) };
  return (
    <MessageBody type={type}>
      {media?.length
        ? media.map((url, idx) => <img key={idx} width="100%" src={url} />)
        : null}
      <Message dangerouslySetInnerHTML={htmlContent} type={type} />
    </MessageBody>
  );
};

export default MessageComponent;
